import React, { useEffect, useState } from "react";
import { createFFmpeg, fetchFile } from "@ffmpeg/ffmpeg";

let ffmpeg = createFFmpeg({
  corePath: "https://unpkg.com/@ffmpeg/core@0.10.0/dist/ffmpeg-core.js",
  log: false
});

const VideoTrim = ({ video, onFinish, onProgress, start, end }) => {
  const [running, setRunning] = useState(false);

  useEffect(() => {
    const formatSeconds = seconds => (new Date(seconds * 1000).toISOString().substr(11, 12));

    const trim = async () => {
      // Write the file to memory
      ffmpeg.FS("writeFile", "video.mp4", await fetchFile(video));
      ffmpeg.setProgress(({ ratio }) => onProgress(ratio * 100));
      await ffmpeg.run("-i", "video.mp4", "-ss", formatSeconds(start), "-to", formatSeconds(end), "converted.mp4");

      // Read the result
      const mp4 = ffmpeg.FS("readFile", "converted.mp4");
      const videoFile = new Blob([mp4.buffer], { type: "video/mp4" });
      onFinish(videoFile);
      setRunning(false);
    };

    const load = async () => {
      if (!ffmpeg.isLoaded()) {
        await ffmpeg.load();
      } else {
        try {
          ffmpeg.exit();
        } catch (_) {
          ffmpeg = createFFmpeg({
            corePath: "https://unpkg.com/@ffmpeg/core@0.10.0/dist/ffmpeg-core.js",
            log: false
          });
          await ffmpeg.load();
          // closing ffmpeg...
        }
      }

      if (!running) {
        setRunning(true);
        await trim();
      }
    };

    load();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [video]);

  return <></>;
};

export default VideoTrim;
